<bn-loading-overlay></bn-loading-overlay>

<h5>Janelas de Apuração</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
		<div class="col">
		  <h3>Filtros de pesquisa</h3>
		</div>

    <div class="col-auto">
      <button type="button" class="btn btn-info" *ngIf="podeCadastrarJanela" [routerLink]="['/janelas-apuracao']"  ngbTooltip="Tela para cadastro da janela."><i class="fa fa-file-signature">
      </i> Nova Janela</button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>

		<div class="col-auto">
		   <button #focusableSubmit type="button" 
		   class="btn btn-success no-margin" (keydown.enter)="buscar()" (click)="buscar()">Pesquisar</button>
		</div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="tranche">Cesta: </label>
        <select id="tranche" class="form-select" formControlName="ideTranche">
          <option [ngValue]=null></option>
          <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
            {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
        </select>
      </div>


      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataInicioJanela">Data Inicio da Janela:</label>
        <bn-datepicker name="dataInicioJanela" idInput="dataInicioJanela" formControlName="dataInicioJanela">
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataFimJanela">Data Fim da Janela:</label>
        <bn-datepicker name="dataFimJanela" idInput="dataFimJanela" formControlName="dataFimJanela">
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="fechamentoRealizado">Fechamento Realizado: </label>
        <select id="fechamentoRealizado" class="form-select" formControlName="fechamentoRealizado">
          <option [ngValue]=null></option>
          <option [ngValue]="true">Sim</option>
          <option [ngValue]="false">Não</option>
        </select>
      </div>

    </div>
    <div class="mt-3 alert alert-info fst-italic">
      Os dados da janela serão utilizados para o Stop Loss, somente após  a realização da data fim do fechamento.
    </div>

  </form>
</div>

<app-janelas-apuracao-listagem *ngIf="pesquisado" [janelas]="janelas" [tranches]="tranches"></app-janelas-apuracao-listagem>
